import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { pickQtySchema } from './pick-qty-schema.js';
// A fresh key per Commit tap, resent unchanged on a retry, becomes the committed row's uuidv7 id.
export const commitPickItemQtyInputSchema = z.object({
    pickItemId: requiredUuidString('Pick item is required.', 'Invalid pick item selection.'),
    qty: pickQtySchema('Enter a quantity to commit.'),
    idempotencyKey: requiredUuidString('Commit key is required.', 'Invalid commit key.').transform((key) => key.toLowerCase()),
});
//# sourceMappingURL=commit-pick-item-qty-input.js.map